import { createSelector } from 'reselect';
import { FixMe, ReduxStore } from 'types/indexTS';
import { DEFAULT_PAGE_FEED_COMMENTS_QUERY } from './constants';
import { PageFeedCommenStateByKey, PageFeedCommentState } from './types';

const pageFeedCommentsState = (state: ReduxStore): PageFeedCommentState => state.pageFeedComments;

const pageFeedComentsStateByComponentKey = createSelector(
  [pageFeedCommentsState, (_state, feedId): string => feedId],
  (pageFeedCommentsStateInfo: PageFeedCommentState, feedId: string): PageFeedCommenStateByKey => {
    return pageFeedCommentsStateInfo?.[feedId] || { ...DEFAULT_PAGE_FEED_COMMENTS_QUERY, feedId };
  },
);

const fetchingCancelToken = createSelector(
  [pageFeedComentsStateByComponentKey],
  (state: PageFeedCommenStateByKey): FixMe => state.fetchingCancelToken,
);

export const pageFeedComentsSelectors = {
  pageFeedComentsStateByComponentKey,
  fetchingCancelToken,
};
